<template>
  <b-modal
    ref="surveyPrompt"
    centered
    hide-header
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
  >
    <div class="p-3 p-lg-4" v-if="loggedIn">
      <p>Hi {{ user.customer.firstname }}!</p>
      <p>Complete your registration and unlock your 5 free U-COINs by answering this quick survey.</p>
      <div class="link-wrapper mt-4 d-flex justify-content-center justify-content-lg-end">
        <b-link
          href="https://app.rush.ph/ucoin-survey"
          target="_blank"
          role="button"
          class="btn btn-core btn-secondary"
        >
          Survey
        </b-link>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      loggedIn: "auth/loggedIn",
      user: "auth/user"
    })
  },
  mounted () {
    this.$root.$on('openSurveyPromptModal', () => {
      this.$refs.surveyPrompt.show();
    });
  },
  beforeDestroy () {
    this.$root.$off('openSurveyPromptModal')
  }
}
</script>
